module.exports = __webpack_public_path__ + "components/MapControl/svg/Pokój gościnny.svg?6dca7c78";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Pokój gościnny.svg
// module id = 2014
// module chunks = 0